/*
 * @Author: bucai
 * @Date: 2020-07-23 15:24:58
 * @LastEditors: bucai
 * @LastEditTime: 2020-07-23 15:50:08
 * @Description:
 */

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    foodList: [],
    tabselect: 0,
    loginTag: 0,
  },
  mutations: {
    SET_TABSELECT(state, payload) {
      state.tabselect = payload;
    },
    SET_FOODLIST(state, payload) {
      state.foodList = payload;
    },
    CHANGE_FOODNUM(state, payload) {
      const { id, num } = payload;
      // state.foodList = payload;
      const index = state.foodList.findIndex((item) => item.id == id);
      const item = state.foodList[index];
      if (item) {
        item.num = num;
        state.foodList.splice(index, 1, item);
      }
    },
    SET_LOGINTAG(state, value) {
      state.loginTag = value;
    },
  },
  actions: {},
});

export default store;
